import React from "react";
import HoverTooltip from "./HoverTooltip";
import infoIcon from "../assets/images/info-icon.svg";
import globalConstants from "../shared/appConfig/globalConstants";

const OVERVIEW_TITLE = globalConstants.Dashboard.OverviewHeaderTitle;
const OVERVIEW_STATS_TOOLTIP = globalConstants.Dashboard.OverviewHeaderTooltipMessage;

const OverviewHeader = ({
	title = OVERVIEW_TITLE,
	tooltipText = OVERVIEW_STATS_TOOLTIP,
	infoIconAriaLabel = "Overview statistics information",
	className = "",
	style,
}) => {
	return (
		<div className={`overview-header ${className}`.trim()} style={style}>
			<h6 className="overview-header__title">{title}</h6>
			<HoverTooltip
				title={tooltipText}
				placement="right"
				classes={{
					tooltip: "overview-header__tooltip-content",
					arrow: "overview-header__tooltip-arrow",
				}}
			>
				<button
					type="button"
					className="overview-header__icon-trigger"
					aria-label={infoIconAriaLabel}
				>
					<img
						className="overview-header__info-icon-img"
						src={infoIcon}
						alt=""
						width={14}
						height={14}
						draggable={false}
						aria-hidden
					/>
				</button>
			</HoverTooltip>
		</div>
	);
};

export default OverviewHeader;
